import React from "react";
import { ProvidersLogoBlock } from "ComponentsUIV2/Blocks";
import { useQuery } from "@apollo/client";
import { PROVIDERS_BY_GLOBAL_ID_QUERY } from "Services/queries";
import { isMainSiteCode, isMoscowSiteCode } from "Utils/siteConfig";
import { HeaderTextSeo } from "ComponentsUI/SeoBlock";

import { pipe } from "Utils";
import { observer, inject } from "mobx-react";

const ProvidersLogoContainer = (props) => {
	const {
		ApplicationModel: { siteCode },
		seoBlock,
	} = props;

	const providers101GlobalsId = [
		7, 8, 5, 6, 9, 4, 106, 757, 51, 61, 55, 1834, 139, 166, 10, 20, 1814, 17, 30, 1700, 14, 1922,
		888, 58,
	];
	const providersMoscowGlobalsId = [
		1611, 5, 20, 8, 9, 30, 1284, 6, 38, 14, 17, 1930, 106, 48, 7, 1700, 64, 51, 4, 1814, 134, 757,
		888, 1922,
	];
	const providersPiterGlobalsId = [
		6, 7, 8, 5, 9, 244, 1310, 757, 1821, 1372, 1671, 1687, 94, 1490, 1407, 1474, 106, 696, 1811, 51,
		4, 19, 909, 61,
	];

	let noneMainSiteProvidersGlobalsId = isMoscowSiteCode(siteCode)
		? providersMoscowGlobalsId
		: providersPiterGlobalsId;
	let providersGlobalsIdBySiteCode = isMainSiteCode(siteCode)
		? providers101GlobalsId
		: noneMainSiteProvidersGlobalsId;

	const { data, loading } = useQuery(PROVIDERS_BY_GLOBAL_ID_QUERY, {
		variables: {
			globals_id_list: providersGlobalsIdBySiteCode,
		},
	});

	if (!data || loading) {
		return null;
	}

	return (
		<>
			<HeaderTextSeo header={seoBlock?.seoHeader} text={seoBlock?.seoText} />
			<ProvidersLogoBlock providers={data.providersByGlobalId.data} />
		</>
	);
};

export default pipe(observer, inject("ApplicationModel"))(ProvidersLogoContainer);
